import { ThreeDots as Loader } from "react-loader-spinner";

import colors from "../../styles/colors";
import { Container, LoaderWrapper } from "./styles";

const LoadingResults = () => (
  <Container>
    <td colSpan={7}>
      <LoaderWrapper>
        <Loader color={colors.primaryLight} height={50} width={50} />
      </LoaderWrapper>
    </td>
  </Container>
);

export default LoadingResults;
